<div @inOutAnimation class="app-loader">

</div>

<div class="loader">
  <mat-spinner diameter="100"></mat-spinner>
</div>
